export const FETCHING_RELOCATION_DECLARATION = 'FETCHING_RELOCATION_DECLARATION';
export const CREATING_RELOCATION_DECLARATION = 'CREATING_RELOCATION_DECLARATION';
export const UPDATING_RELOCATION_DECLARATION = 'UPDATING_RELOCATION_DECLARATION';
export const DELETING_RELOCATION_DECLARATION = "DELETING_RELOCATION_DECLARATION";

export const FETCHING_FILES = 'FETCHING_FILES';
export const UPLOADING_FILE = 'UPLOADING_FILE';
export const DELETING_FILE = 'DELETING_FILE';
export const SHARING_FILES = 'SHARING_FILES';
export const FETCHING_MESSAGE = 'FETCHING_MESSAGE';

export const FETCHING_USER_SERVICES_DATA = 'FETCHING_USER_SERVICES_DATA';
export const UPDATING_USER_SERVICES_DATA = 'UPDATING_USER_SERVICES_DATA';
export const CREATING_USER_SERVICES_DATA = 'UPDATING_USER_SERVICES_DATA';
export const DELETING_USER_SERVICES_DATA = 'DELETING_USER_SERVICES_DATA';
export const COMPLETING_USER_SERVICES_DATA = 'COMPLETING_USER_SERVICES_DATA';
export const GENERATING_USER_LETTERS = 'GENERATING_USER_LETTERS';
export const FETCHING_USER_LETTERS = 'FETCHING_USER_LETTERS';
export const UPDATING_USER_LETTER = 'UPDATING_USER_LETTER';
export const FETCHING_REFERENTS = 'FETCHING_REFERENTS';
export const UPDATING_REFERENT = 'UPDATING_REFERENT';
export const DELETING_REFERENT = 'DELETING_REFERENT';
export const CREATING_REFERENT = 'CREATING_REFERENT';

export const FETCHING_USER_CONNECTION = 'FETCHING_USER_CONNECTION';
export const ADDING_USER_CONNECTION = 'ADDING_USER_CONNECTION';
export const ADDING_USER_CONNECTION_BATCH = 'ADDING_USER_CONNECTION_BATCH';
export const REMOVING_USER_CONNECTION = 'REMOVING_USER_CONNECTION';

export const FETCHING_USER = 'FETCHING_USER';
export const UPDATING_USER = 'UPDATING_USER';
export const FETCHING_ONBOARDINGUSER_ADDRESS = 'FETCHING_ONBOARDINGUSER_ADDRESS';
export const UPDATING_USER_ONBOARDINGSTEP = 'UPDATING_USER_ONBOARDINGSTEP';



export const INVITING_REPRESENTATIVE = 'INVITING_REPRESENTATIVE';